export const PRICES = {
  // SLIDES
  volcano19: { dry: 390, wet: 415 },
  funSplash15: { dry: 275, wet: 325 },
  rainbowRush18: { dry: 375, wet: 425 },
  dolphin16: { dry: 350, wet: 400 },
  
  // COMBOS
  doubleJumbo: { dry: 320, wet: 355 },
  primaryCombo: { dry: 270, wet: 320 },
  princessCombo: { dry: 270, wet: 320 },
  whitePrincess: { dry: 290, wet: 340 },

  // BOUNCE HOUSES
  primaryBounce: { dry: 270, wet: 320 },

  // OBSTACLE COURSES
  funRunObstacle: { dry: 370, wet: 420 },

  // ADD‑ONS & FLAT‑RATE ITEMS
  softPlay: { price: 320 },
  foamBlaster: { price: 275, extra6Hours: 125, firstHour: 275, additionalHour: 125 },
  snowCone: { price: 90, extraSyrup: 25 }
};
